import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { AuthProvider } from './auth';
import { readOrgLocation } from './lib/orgContext';
import App from './App';
import './styles.css';

const root = document.getElementById('root');
if (!root) throw new Error('ไม่พบ element #root');

/**
 * เส้นทางทั้งหมดอยู่ใต้ /o/<slug> เมื่อลิงก์ระบุมูลนิธิ
 *
 * ต้องตั้ง basename ไม่งั้น <Link to="/"> จะพาออกไปนอก path ของมูลนิธิ
 * แล้วแอปกลับไปใช้มูลนิธิเริ่มต้น = สลับมูลนิธิกลางคันโดยไม่มีใครสั่ง
 * ซึ่งฝั่งผู้บริจาคแปลว่า QR พร้อมเพย์เปลี่ยนบัญชีปลายทาง
 */
const { basename } = readOrgLocation();

createRoot(root).render(
  <StrictMode>
    <BrowserRouter basename={basename || undefined}>
      <AuthProvider>
        <App />
      </AuthProvider>
    </BrowserRouter>
  </StrictMode>,
);
